import { render, staticRenderFns } from "./refAddGrade2GOSTDialog.vue?vue&type=template&id=4f7eb4d8"
import script from "./refAddGrade2GOSTDialog.vue?vue&type=script&lang=js"
export * from "./refAddGrade2GOSTDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports